import React from 'react';
import { IconSvgProps } from '@models/common';

const Send: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'>
      <path
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        d='M9.59895 12.0979L13.1813 10.3184M9.14127 11.783L3.7801 8.09421C2.97012 7.5369 3.36636 6.26781 4.34955 6.27038L19.2417 6.30933C20.0657 6.31149 20.5336 7.25348 20.0375 7.91142L11.0711 19.8017C10.4791 20.5868 9.22841 20.1358 9.27369 19.1536L9.57337 12.6529C9.58928 12.3077 9.4259 11.9788 9.14127 11.783Z'
      />
    </svg>
  );
};

export default Send;
